import React from 'react';
import PropTypes from 'prop-types';
import styles from './InputWithSuggestions.scss';

const Suggestion = ({ active, description, title }) => (
  <div className={[styles.option, active ? styles.selected : ''].join(' ')}>
    <div className={styles.title}>
      {title}
    </div>
    <div className={styles.description}>
      {description}
    </div>
  </div>
);

Suggestion.propTypes = {
  active: PropTypes.bool,
  description: PropTypes.string,
  title: PropTypes.string
};

export default Suggestion;



// WEBPACK FOOTER //
// ./webpack/components/Elements/InputWithSuggestions/Suggestion.js